module.exports = __webpack_public_path__ + "media/images/pictograms/pic6-eb7e562c8d18949f638104c32e3f0900.png";